/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/TimeOutOfSyncNotice/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let timeNowValueData = fromData.useDataValue({ viewPath,
context: 'time',
path: 'now',
})
let timeLocalValueData = fromData.useDataValue({ viewPath,
context: 'time',
path: 'local',
})
let aggregateData = fromHelpers.isOutOfSync(timeNowValueData, timeLocalValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}